import { Twitter, Instagram, Mail } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useSmoothScroll } from "../../hooks/useSmoothScroll";

export function Footer() {
  const { scrollToElement } = useSmoothScroll();
  const location = useLocation();

  const handleSamePageLink = (e, to) => {
    if (!to) return;
    if (location?.pathname === to) {
      e.preventDefault();
      try { window.scrollTo({ top: 0, left: 0, behavior: 'smooth' }); }
      catch { window.scrollTo(0, 0); }
    }
  };

  const handleInternalLink = (e, elementId) => {
    e.preventDefault();
    scrollToElement(elementId);
  };

  return (
    <footer className="bg-background border-t border-border py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent mb-4">
              キャッシュレス決済マップ
            </h3>
            <p className="text-muted-foreground text-sm">
              2026年3月にサービスを終了しました。<br />
              ご利用いただき、ありがとうございました。
            </p>
          </div>

          <div>
            <h4 className="mb-4">サービス</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <button 
                  onClick={(e) => handleInternalLink(e, 'features')}
                  className="text-muted-foreground hover:text-foreground transition-colors text-left"
                >
                  機能
                </button>
              </li>
              <li>
                <button 
                  onClick={(e) => handleInternalLink(e, 'pricing')}
                  className="text-muted-foreground hover:text-foreground transition-colors text-left"
                >
                  料金プラン
                </button>
              </li>
              <li>
                <span className="text-muted-foreground">店舗検索：提供終了</span>
              </li>
              <li>
                <span className="text-muted-foreground">店舗登録：受付終了</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4">サポート</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <button 
                  onClick={(e) => handleInternalLink(e, 'faq')}
                  className="text-muted-foreground hover:text-foreground transition-colors text-left"
                >
                  よくある質問
                </button>
              </li>
              <li>
                <a href="mailto:customer-support-cashless@cashlessmap.com" className="text-muted-foreground hover:text-foreground transition-colors">
                  お問い合わせ
                </a>
              </li>
              <li>
                <span className="text-muted-foreground">オーナー申請：受付終了</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4">法務情報</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/legal/terms" onClick={(e)=>handleSamePageLink(e,'/legal/terms')} className="text-muted-foreground hover:text-foreground transition-colors">
                  利用規約
                </Link>
              </li>
              <li>
                <Link to="/legal/privacy" onClick={(e)=>handleSamePageLink(e,'/legal/privacy')} className="text-muted-foreground hover:text-foreground transition-colors">
                  プライバシーポリシー
                </Link>
              </li>
              <li>
                <Link to="/legal/tokushoho" onClick={(e)=>handleSamePageLink(e,'/legal/tokushoho')} className="text-muted-foreground hover:text-foreground transition-colors">
                  特定商取引法表示
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-border">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mb-4">
            <p className="text-sm text-muted-foreground">
              © 2025 Cashless Map. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://twitter.com/cashlessmap"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-muted hover:bg-accent flex items-center justify-center transition-colors"
              >
                <Twitter size={18} className="text-muted-foreground" />
              </a>
              <a
                href="https://instagram.com/cashlessmap"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-muted hover:bg-accent flex items-center justify-center transition-colors"
              >
                <Instagram size={18} className="text-muted-foreground" />
              </a>
              <a
                href="mailto:customer-support-cashless@cashlessmap.com"
                className="w-10 h-10 rounded-full bg-muted hover:bg-accent flex items-center justify-center transition-colors"
              >
                <Mail size={18} className="text-muted-foreground" />
              </a>
            </div>
          </div>
          <div className="text-xs text-muted-foreground text-center sm:text-left">
            <p className="mb-1">
              各決済ブランド名・ロゴは各社の商標または登録商標です。
            </p>
            <p>
              決済処理はStripeを使用しており、TLS暗号化により保護されています。当社はカード情報を保持しません。
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
